import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import ListInfo from "./ListInfo";
import List from "./List";
import Filter from "./Filter";
import ExportFiles from "./ExportFiles";
import PaginationBox from "./PaginationBox";
import styles from "./DataGrid.module.scss";

const DataGrid = ({ children, className }) => {
  let listInfo = null;
  let list = null;
  let filter = null;
  let exportFiles = null;
  let paginationBox = null;
  React.Children.forEach(children, child => {
    if (child?.type === ListInfo) {
      listInfo = child;
    }
    if (child?.type === Filter) {
      filter = child;
    }
    if (child?.type === ExportFiles) {
      exportFiles = child;
    }
    if (child?.type === List) {
      list = child;
    }
    if (child?.type === PaginationBox) {
      paginationBox = child;
    }
  });

  return (
    <div className={cn(styles.dataGrid, className)}>
      <div className={styles.actions}>
        {filter || listInfo}
        {exportFiles}
      </div>
      {filter && listInfo}
      {list}
      {paginationBox}
    </div>
  );
};

DataGrid.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

DataGrid.defaultProps = {
  children: null,
  className: ""
};

export default DataGrid;
